export const FETCH_FAVORITE = 'FETCH_FAVORITE';
export const FETCH_FAVORITE_SUCCEED = 'FETCH_FAVORITE_SUCCEED';
export const FETCH_FAVORITE_FAILED = 'FETCH_FAVORITE_FAILED';

export const CREATE_FAVORITE = 'CREATE_FAVORITE';
export const CREATE_FAVORITE_SUCCEED = 'CREATE_FAVORITE_SUCCEED';
export const CREATE_FAVORITE_FAILED = 'CREATE_FAVORITE_FAILED';

export const FETCH_FAVORITE_DETAIL = 'FETCH_FAVORITE_DETAIL';
export const FETCH_FAVORITE_DETAIL_SUCCEED = 'FETCH_FAVORITE_DETAIL_SUCCEED';
export const FETCH_FAVORITE_DETAIL_FAILED = 'FETCH_FAVORITE_DETAIL_FAILED';

export const REMOVE_FAVORITE = 'REMOVE_FAVORITE';
export const REMOVE_FAVORITE_SUCCEED = 'REMOVE_FAVORITE_SUCCEED';
export const REMOVE_FAVORITE_FAILED = 'REMOVE_FAVORITE_FAILED';
